import {
  CallToken,
  CallTokenPersistence,
} from '../components/TokenValidationModal/types'

class CallTokenSerializer {
  toPersistence(data: CallToken): CallTokenPersistence {
    return {
      idAtendimento: Number(data?.attendanceId),
      idProfissional: Number(data?.professionalId),
      dataHoraAgendamento: data?.date?.replace(',', '') || '',
      tokenAutorizacaoExterno: data?.externalAuthorizationToken,
      numeroGuiaPrestador: data?.providerGuideNumber,
    }
  }
}

export default new CallTokenSerializer()
